<i nz-icon nzType="close" nz-tooltip nzTooltipTrigger="click" [nzTooltipTitle]="message"></i>
